export default __webpack_public_path__ + "static/media/coin_stack.dc54d944.png";